import { Component, OnInit, Input, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CameraServiceService } from 'src/app/services/multimedia/camera-service.service';
import { MediaItem } from 'src/app/Models/Classes/Media/media-item';
import { FormServiceService } from 'src/app/services/publications/form-service.service';
import { PublicationService } from 'src/app/services/publications/publication.service';
import { Utils } from 'src/app/Models/Classes/utils';
import * as uuid from 'uuid';
//import {Filesystem, FilesystemDirectory} from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';
import { isVideo,isImage } from 'src/app/utils';
import Swal2 from 'sweetalert2';
import {RequestService} from '../../services/request/request.service';
import {Router} from "@angular/router";
import {UploadMultimediaService} from "../../services/upload/upload-multimedia.service";
import { Camera as CapacitorCamera, CameraResultType, CameraSource } from '@capacitor/camera';

import { ChangeDetectorRef } from '@angular/core';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { v4 as uuidv4 } from 'uuid';
import { File } from '@ionic-native/file/ngx';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { StoryMediaPickerComponent } from './story-media-picker.component';
import { NativeStoryMedia } from 'src/app/plugins/native-runtime.plugins';





declare var MediaRecorder;

defineCustomElements(window);
declare var navigator: any;
declare var ImagePicker: any;
@Component({
  selector: 'app-history-view',
  templateUrl: './history-view.component.html',
  styleUrls: ['./history-view.component.scss'],
})



export class HistoryViewComponent implements OnInit, OnDestroy {
  @Input() composerMode: 'story' | 'social' = 'story';
  readonly isNativePlatform = Capacitor.getPlatform() !== 'web';
  @ViewChild('imageFilePicker') imageFilePicker?: ElementRef<HTMLInputElement>;
  @ViewChild('videoFilePicker') videoFilePicker?: ElementRef<HTMLInputElement>;
  @ViewChild('cameraImagePicker') cameraImagePicker?: ElementRef<HTMLInputElement>;
  @ViewChild('cameraVideoPicker') cameraVideoPicker?: ElementRef<HTMLInputElement>;
  @ViewChild('cameraPreview') cameraPreview?: ElementRef<HTMLVideoElement>;
  @ViewChild('mediaFilePicker') mediaFilePicker?: ElementRef<HTMLInputElement>;
  @ViewChild('storyTopbar') storyTopbar?: ElementRef<HTMLElement>;
  @ViewChild('storyCameraActions') storyCameraActions?: ElementRef<HTMLElement>;
  @ViewChild('storyReviewControls') storyReviewControls?: ElementRef<HTMLElement>;
  stream;
  private readonly storyControlNodes: HTMLElement[] = [];
  private readonly syncStoryControlViewport = (): void => {
    if (this.destroyed || typeof window === 'undefined') return;
    const viewport = window.visualViewport;
    const visibleBottom = (viewport?.offsetTop || 0) + (viewport?.height || window.innerHeight);
    const bottomInset = Math.max(0, Math.round(window.innerHeight - visibleBottom));
    if (this.storyReviewControls) {
      this.storyReviewControls.nativeElement.style.bottom = `calc(env(safe-area-inset-bottom, 0px) + ${bottomInset + 16}px)`;
    }
  };
  private cameraOpening = false;
  private destroyed = false;
  private capturePressTimer: ReturnType<typeof setTimeout> | null = null;
  private recordingClockTimer: ReturnType<typeof setInterval> | null = null;
  private capturePressActive = false;
  private longPressTriggered = false;
  private discardRecordingOnStop = false;
  private recordingStartedAt = 0;
  private recordingElapsedMs = 0;
  recordingLimitSeconds: 60 | 600 = 60;
  recordingSeconds = 0;
  isRecording = false;
  isRecordingPaused = false;
  isCapturingVideo = false;
  cameraReady = false;
  cameraError = '';
  isPublishing = false;
  isStoryPickerOpen = false;
  previewUrl = '';
  imagePreviewError = false;
  videoPreviewError = false;
  recentPhotoThumbnail = '';
  recentVideoThumbnail = '';
  selectedMediaBlob: Blob | null = null;
  selectedMediaFilename = '';
  safeVideoUrl: SafeResourceUrl;
  private mediaRecorder: any;
  private recordingAudioStream: MediaStream | null = null;
  private recordingChunks: Blob[] = [];
  public multimedia: Array<MediaItem> = new Array<MediaItem>();
  @Input() publication: any;
// Add mediaType property to the class
mediaType: string;

  image: any;
 // video: any;
  ruta: Array<object>=[];
  historias: Array<object> =[];
  titulo='';
  allowEdit: boolean=false;




  constructor(

    public modalController: ModalController,
    private router: Router,
    private cameraService: CameraServiceService,
    public formservice: FormServiceService,
    private publicationService: PublicationService,
    private request: RequestService,
    private utils: Utils,
    private uploadMultimedia: UploadMultimediaService,
    private ref: ChangeDetectorRef,
    private file: File, 
    private sanitizer: DomSanitizer,
    ) { }
ngOnDestroy() {
  this.destroyed = true;
  window.removeEventListener('resize', this.syncStoryControlViewport);
  window.visualViewport?.removeEventListener('resize', this.syncStoryControlViewport);
  window.visualViewport?.removeEventListener('scroll', this.syncStoryControlViewport);
  this.storyControlNodes.forEach(node => node.remove());
  document.body.classList.add('dark');
  this.stopMedia();
  this.releasePreviewUrl();
}
  ngOnInit() {
    this.formservice.history = [];
    this.image = '';
    this.uploadMultimedia.image = '';
    document.body.classList.remove('dark');
  }
  ngAfterViewInit(){
    void this.loadRecentMediaThumbnails();
    // Inline previews are display-only. Explicitly suppress the iOS media
    // playback overlay so a camera or story preview never shows a pause icon.
    this.cameraPreview?.nativeElement.parentElement?.querySelectorAll<HTMLVideoElement>('.story-camera, .story-preview').forEach(video => {
      video.controls = false;
      video.removeAttribute('controls');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
    });
    // Ionic can retain stale modal dimensions after the native media picker
    // returns. Keep controls in the viewport layer instead of that layout box.
    for (const ref of [this.storyTopbar, this.storyCameraActions, this.storyReviewControls]) {
      if (!ref) continue;
      document.body.appendChild(ref.nativeElement);
      this.storyControlNodes.push(ref.nativeElement);
    }
    this.syncStoryControlViewport();
    requestAnimationFrame(this.syncStoryControlViewport);
    setTimeout(this.syncStoryControlViewport, 250);
    window.addEventListener('resize', this.syncStoryControlViewport);
    window.visualViewport?.addEventListener('resize', this.syncStoryControlViewport);
    window.visualViewport?.addEventListener('scroll', this.syncStoryControlViewport);
    setTimeout(() => void this.camera(), 0);
  }

  private async loadRecentMediaThumbnails(): Promise<void> {
    if (Capacitor.getPlatform() !== 'ios') return;
    try {
      const thumbnails = await NativeStoryMedia.latestThumbnails();
      if (this.destroyed) return;
      this.recentPhotoThumbnail = thumbnails?.photo || '';
      this.recentVideoThumbnail = thumbnails?.video || '';
      this.ref.detectChanges();
    } catch (error) {
      // Buttons remain available with their standard icons if Photos access
      // or thumbnail generation is unavailable.
      console.debug('Recent story media thumbnails are unavailable', error);
    }
  }
  async camera(): Promise<void> {
    if (this.cameraOpening || this.stream || this.selectedMediaBlob || this.destroyed) return;
    const video = this.cameraPreview?.nativeElement;
    if (!video || !navigator.mediaDevices?.getUserMedia) {
      this.cameraError = 'No se pudo abrir la cámara. Puedes elegir una foto o un video.';
      return;
    }
    this.cameraOpening = true;
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: { ideal: 'environment' }, width: { ideal: 1280 }, height: { ideal: 720 } },
        audio: false,
      });
      if (this.destroyed || this.selectedMediaBlob) {
        stream.getTracks().forEach(track => track.stop());
        return;
      }
      this.stream = stream;
      video.srcObject = this.stream;
      video.muted = true;
      await video.play();
      this.cameraReady = true;
      this.cameraError = '';
      this.ref.detectChanges();
    } catch (error) {
      console.error('Error accessing the camera', error);
      this.stream?.getTracks().forEach(track => track.stop());
      this.stream = null;
      if (video) video.srcObject = null;
      this.cameraReady = false;
      this.cameraError = 'No se pudo abrir la cámara. Revisa los permisos o elige un archivo.';
      this.ref.detectChanges();
    } finally {
      this.cameraOpening = false;
    }
  }

  async capturePhoto(): Promise<void> {
    const preview = this.cameraPreview?.nativeElement;
    const livePhoto = this.cameraReady ? await this.captureCurrentVideoFrame(preview) : null;
    if (livePhoto) {
      this.setSelectedMedia(livePhoto, this.createFilename('jpg'), 'image');
      this.ref.detectChanges();
      return;
    }
    if (this.isNativePlatform) {
      try {
        const photo = await CapacitorCamera.getPhoto({
          quality: 90,
          allowEditing: false,
          resultType: CameraResultType.Uri,
          source: CameraSource.Camera,
          saveToGallery: false,
          correctOrientation: true,
        });
        const photoUrl = photo.webPath || (photo.path ? Capacitor.convertFileSrc(photo.path) : '');
        if (!photoUrl) throw new Error('The camera did not return a photo URL.');
        const response = await fetch(photoUrl);
        if (!response.ok) throw new Error('The captured photo could not be read.');
        const blob = await response.blob();
        if (!blob.size) throw new Error('The captured photo is empty.');
        const extension = photo.format === 'png' ? 'png' : 'jpg';
        this.setSelectedMedia(blob, this.createFilename(extension), 'image');
        this.ref.detectChanges();
      } catch (error) {
        if (!this.isMediaPickerCancellation(error)) {
          console.error('Unable to capture story photo', error);
          if (this.cameraImagePicker?.nativeElement) {
            this.cameraImagePicker.nativeElement.click();
          } else {
            this.cameraError = 'No se pudo tomar la foto. Inténtalo de nuevo.';
          }
        }
      }
      return;
    }

    if (!this.cameraReady) {
      await this.camera();
    }
    const webPhoto = await this.captureCurrentVideoFrame(this.cameraPreview?.nativeElement);
    if (!webPhoto) {
      this.cameraError = 'La cámara no entregó una imagen. Elige una foto de tu dispositivo.';
      this.cameraImagePicker?.nativeElement.click();
      return;
    }
    this.setSelectedMedia(webPhoto, this.createFilename('jpg'), 'image');
    this.ref.detectChanges();
  }

  private async captureCurrentVideoFrame(video?: HTMLVideoElement): Promise<Blob | null> {
    if (!video || video.paused || video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA || !video.videoWidth || !video.videoHeight) return null;
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const context = canvas.getContext('2d');
    if (!context) return null;
    try {
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      const sample = document.createElement('canvas');
      sample.width = sample.height = 16;
      const sampleContext = sample.getContext('2d');
      if (!sampleContext) return null;
      sampleContext.drawImage(canvas, 0, 0, 16, 16);
      const pixels = sampleContext.getImageData(0, 0, 16, 16).data;
      let hasVisiblePixel = false;
      for (let i = 0; i < pixels.length; i += 4) {
        if (pixels[i] > 3 || pixels[i + 1] > 3 || pixels[i + 2] > 3) {
          hasVisiblePixel = true;
          break;
        }
      }
      if (!hasVisiblePixel) return null;
    } catch (error) {
      console.warn('Unable to read the current camera frame', error);
      return null;
    }
    const blob = await new Promise<Blob | null>(resolve => canvas.toBlob(resolve, 'image/jpeg', 0.92));
    return blob?.size ? blob : null;
  }

  async toggleVideoRecording(): Promise<void> {
    if (this.isRecording) {
      this.pauseOrResumeVideoRecording();
      return;
    }
    if (!this.stream) await this.camera();
    if (!this.stream || typeof MediaRecorder === 'undefined') {
      if (this.isNativePlatform) void this.captureNativeVideo();
      else this.cameraVideoPicker?.nativeElement.click();
      return;
    }
    try {
      // Keep the live preview muted; audio is acquired only for the recording.
      try {
        this.recordingAudioStream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
      } catch {
        this.recordingAudioStream = null;
      }
      const recordingStream = new MediaStream([
        ...this.stream.getVideoTracks(),
        ...(this.recordingAudioStream?.getAudioTracks() || []),
      ]);
      const supportedMimeType = ['video/mp4', 'video/webm;codecs=vp8', 'video/webm']
        .find(type => MediaRecorder.isTypeSupported?.(type));
      const options = { ...(supportedMimeType ? { mimeType: supportedMimeType } : {}), videoBitsPerSecond: 1500000 };
      this.recordingChunks = [];
      this.discardRecordingOnStop = false;
      this.mediaRecorder = new MediaRecorder(recordingStream, options);
      this.mediaRecorder.ondataavailable = (event: any) => {
        if (event.data?.size) this.recordingChunks.push(event.data);
      };
      this.mediaRecorder.onstop = () => {
        this.clearRecordingTimers();
        this.recordingAudioStream?.getTracks().forEach(track => track.stop());
        this.recordingAudioStream = null;
        const blob = new Blob(this.recordingChunks, { type: this.mediaRecorder.mimeType || this.recordingChunks[0]?.type || 'video/mp4' });
        this.recordingChunks = [];
        const extension = blob.type.includes('mp4') ? 'mp4' : 'webm';
        if (!this.discardRecordingOnStop && blob.size) this.setSelectedMedia(blob, this.createFilename(extension), 'video');
        this.discardRecordingOnStop = false;
        this.isRecording = false;
        this.isRecordingPaused = false;
        this.formservice.recording_icon = 'radio-button-on';
        this.ref.detectChanges();
      };
      this.mediaRecorder.start();
      this.isRecording = true;
      this.isRecordingPaused = false;
      this.startRecordingTimers();
      this.formservice.recording_icon = 'square';
    } catch (error) {
      this.recordingAudioStream?.getTracks().forEach(track => track.stop());
      this.recordingAudioStream = null;
      console.error('Unable to record story video', error);
      if (this.isNativePlatform) void this.captureNativeVideo();
      else this.cameraError = 'No se pudo iniciar la grabación. Puedes elegir un video de tu dispositivo.';
    }
  }

  async pickImage(): Promise<void> {
    if (!this.isNativePlatform) {
      this.imageFilePicker?.nativeElement.click();
      return;
    }
    try {
      const photo = await CapacitorCamera.getPhoto({
        quality: 90,
        allowEditing: false,
        resultType: CameraResultType.Uri,
        source: CameraSource.Photos,
        saveToGallery: false,
      });
      const photoUrl = photo.webPath || (photo.path ? Capacitor.convertFileSrc(photo.path) : '');
      if (!photoUrl) throw new Error('The photo picker did not return a URL.');
      const response = await fetch(photoUrl);
      if (!response.ok) throw new Error('The selected photo could not be read.');
      const blob = await response.blob();
      if (!blob.size) throw new Error('The selected photo is empty.');
      const extension = photo.format === 'png' ? 'png' : 'jpg';
      this.setSelectedMedia(blob, this.createFilename(extension), 'image');
      this.ref.detectChanges();
    } catch (error) {
      if (!this.isMediaPickerCancellation(error)) {
        console.error('Unable to pick story photo', error);
        if (this.imageFilePicker?.nativeElement) {
          this.imageFilePicker.nativeElement.click();
        } else {
          this.cameraError = 'No se pudo abrir tu galería. Inténtalo de nuevo.';
        }
      }
    }
  }

  async pickVideo(): Promise<void> {
    if (Capacitor.getPlatform() === 'ios') {
      await this.openStoryMediaPicker('videos');
      return;
    }
    // iOS Photos can return a URI without a recognizable extension through
    // the Cordova picker. A file input yields the actual video File instead.
    this.videoFilePicker?.nativeElement.click();
  }

  async pickStoryMedia(): Promise<void> {
    if (Capacitor.getPlatform() === 'ios') {
      await this.openStoryMediaPicker('all');
      return;
    }
    this.mediaFilePicker?.nativeElement.click();
  }

  private async openStoryMediaPicker(initialFilter: 'all' | 'videos'): Promise<void> {
    if (this.isStoryPickerOpen) return;
    this.isStoryPickerOpen = true;
    this.stopMedia();
    this.ref.detectChanges();
    try {
      const modal = await this.modalController.create({
        component: StoryMediaPickerComponent,
        componentProps: { initialFilter },
        cssClass: 'story-media-picker-modal',
        backdropDismiss: false,
        showBackdrop: false,
      });
      await modal.present();
      const { data, role } = await modal.onDidDismiss();
      if (role === 'selected' && data?.blob instanceof Blob && data?.blob.size) {
        this.setSelectedMedia(data.blob, data.filename, data.type);
      }
    } catch (error) {
      console.error('Unable to open the story media library', error);
      this.cameraError = 'No se pudo abrir tu fototeca. Inténtalo de nuevo.';
    } finally {
      this.isStoryPickerOpen = false;
      if (!this.destroyed) {
        void this.loadRecentMediaThumbnails();
        this.ref.detectChanges();
        if (!this.selectedMediaBlob) void this.camera();
      }
    }
  }

  get recordingTime(): string {
    const minutes = Math.floor(this.recordingSeconds / 60);
    const seconds = this.recordingSeconds % 60;
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
  }

  get recordingStrokeOffset(): number {
    const circumference = 2 * Math.PI * 46;
    return circumference * (1 - Math.min(this.recordingSeconds / this.recordingLimitSeconds, 1));
  }

  setRecordingLimit(seconds: 60 | 600): void {
    if (!this.isRecording) this.recordingLimitSeconds = seconds;
  }

  pauseOrResumeVideoRecording(): void {
    if (!this.isRecording || !this.mediaRecorder) return;
    try {
      if (this.isRecordingPaused) {
        this.mediaRecorder.resume();
        this.recordingStartedAt = Date.now();
        this.isRecordingPaused = false;
      } else {
        this.mediaRecorder.pause();
        this.recordingElapsedMs += Date.now() - this.recordingStartedAt;
        this.isRecordingPaused = true;
      }
      this.updateRecordingClock();
      this.ref.detectChanges();
    } catch (error) {
      console.error('Unable to pause or resume story recording', error);
      this.cameraError = 'No se pudo pausar o continuar la grabación. Toca ✓ para guardar el video.';
    }
  }

  finishVideoRecording(): void {
    if (!this.isRecording || !this.mediaRecorder) return;
    if (!this.isRecordingPaused) {
      this.recordingElapsedMs += Date.now() - this.recordingStartedAt;
      this.isRecordingPaused = true;
    }
    this.updateRecordingClock();
    this.clearRecordingTimers();
    if (this.mediaRecorder.state !== 'inactive') this.mediaRecorder.stop();
  }

  discardRecording(): void {
    if (!this.isRecording) return;
    this.discardRecordingOnStop = true;
    this.finishVideoRecording();
  }

  onCapturePointerDown(event: PointerEvent): void {
    if (this.isCapturingVideo || this.selectedMediaBlob) return;
    event.preventDefault();
    this.capturePressActive = true;
    this.longPressTriggered = false;
    if (this.isRecording) return;
    this.capturePressTimer = setTimeout(() => {
      if (!this.capturePressActive) return;
      this.longPressTriggered = true;
      void this.toggleVideoRecording();
    }, 400);
  }

  onCapturePointerUp(event: PointerEvent): void {
    if (!this.capturePressActive) return;
    event.preventDefault();
    this.capturePressActive = false;
    this.clearCapturePressTimer();
    if (this.longPressTriggered) return;
    if (this.isRecording) this.pauseOrResumeVideoRecording();
    else void this.capturePhoto();
  }

  onCapturePointerCancel(): void {
    this.capturePressActive = false;
    this.clearCapturePressTimer();
  }

  onCaptureKeyboardClick(event: MouseEvent): void {
    // Pointer input is handled above. A keyboard-generated click has detail 0.
    if (event.detail !== 0) return;
    if (this.isRecording) this.pauseOrResumeVideoRecording();
    else void this.capturePhoto();
  }

  private clearCapturePressTimer(): void {
    if (this.capturePressTimer) clearTimeout(this.capturePressTimer);
    this.capturePressTimer = null;
  }

  private startRecordingTimers(): void {
    this.clearRecordingTimers();
    this.recordingElapsedMs = 0;
    this.recordingSeconds = 0;
    this.recordingStartedAt = Date.now();
    this.recordingClockTimer = setInterval(() => {
      this.updateRecordingClock();
      if (this.recordingSeconds >= this.recordingLimitSeconds) this.finishVideoRecording();
      this.ref.detectChanges();
    }, 250);
  }

  private updateRecordingClock(): void {
    const activeMs = this.isRecordingPaused ? 0 : Date.now() - this.recordingStartedAt;
    this.recordingSeconds = Math.min(this.recordingLimitSeconds, Math.floor((this.recordingElapsedMs + activeMs) / 1000));
  }

  private clearRecordingTimers(): void {
    if (this.recordingClockTimer) clearInterval(this.recordingClockTimer);
    this.recordingClockTimer = null;
  }

  onMediaFileSelected(event: Event, preferredType: 'image' | 'video'): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    input.value = '';
    if (!file) return;

    const type = file.type.startsWith('video/') || /\.(mov|mp4|m4v|webm|avi)$/i.test(file.name)
      ? 'video' : file.type.startsWith('image/') ? 'image' : preferredType;
    this.setSelectedMedia(file, file.name || this.createFilename(type === 'video' ? 'mp4' : 'jpg'), type);
    this.ref.detectChanges();
  }

  private async captureNativeVideo(): Promise<void> {
    if (this.isCapturingVideo) return;
    this.isCapturingVideo = true;
    this.cameraError = '';
    try {
      const mediaItem = await this.cameraService.takeVideo(this.recordingLimitSeconds);
      const mediaPath = `${mediaItem.mediaPath || ''}${mediaItem.nameFile || ''}`;
      if (!mediaPath) throw new Error('The video capture did not return a file path.');
      const blob = await this.cameraService.convertUriToBlob(mediaPath);
      if (!blob.size) throw new Error('The captured video is empty.');
      const filename = mediaItem.nameFile || this.createFilename(blob.type.includes('mp4') ? 'mp4' : 'mov');
      this.setSelectedMedia(blob, filename, 'video');
      this.ref.detectChanges();
    } catch (error) {
      if (!this.isMediaPickerCancellation(error)) {
        console.error('Unable to capture story video', error);
        if (this.cameraVideoPicker?.nativeElement) {
          this.cameraVideoPicker.nativeElement.click();
        } else {
          this.cameraError = 'No se pudo grabar el video. Puedes elegir uno de tu dispositivo.';
        }
      }
    } finally {
      this.isCapturingVideo = false;
      this.ref.detectChanges();
    }
  }

  private isMediaPickerCancellation(error: any): boolean {
    const message = String(error?.message || error || '').toLowerCase();
    return message.includes('cancel') || message.includes('user denied') || message.includes('user cancelled');
  }

  private createFilename(extension: string): string {
    return `${new Date().toISOString().replace(/[:.]/g, '-')}.${extension}`;
  }

  private setSelectedMedia(blob: Blob, filename: string, type: 'image' | 'video'): void {
    this.stopMedia();
    this.releasePreviewUrl();
    this.imagePreviewError = false;
    this.videoPreviewError = type === 'video';
    this.selectedMediaBlob = blob;
    this.selectedMediaFilename = filename;
    this.mediaType = type;
    this.previewUrl = URL.createObjectURL(blob);
    this.safeVideoUrl = type === 'video' ? this.sanitizer.bypassSecurityTrustResourceUrl(this.previewUrl) : null;
    this.uploadMultimedia.image = type === 'image' ? this.previewUrl : '';
    const mediaItem = new MediaItem({
      type: blob.type || (type === 'video' ? 'video/mp4' : 'image/jpeg'),
      name: filename,
      size: blob.size,
      status: 'Esperando Media',
    });
    this.multimedia = [mediaItem];
    if (this.publication) {
      this.publication.multimediaContainer = this.multimedia;
      this.publication.doesItHaveMultimedia = true;
    }
    this.cameraError = '';
  }

  private releasePreviewUrl(): void {
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
    this.previewUrl = '';
    this.safeVideoUrl = null;
  }

  discardSelectedMedia(): void {
    this.releasePreviewUrl();
    this.imagePreviewError = false;
    this.videoPreviewError = false;
    this.selectedMediaBlob = null;
    this.selectedMediaFilename = '';
    this.mediaType = '';
    this.uploadMultimedia.image = '';
    this.multimedia = [];
    if (this.publication) {
      this.publication.multimediaContainer = this.multimedia;
      this.publication.doesItHaveMultimedia = false;
    }
    setTimeout(() => void this.camera(), 0);
  }
  stopMedia(){
    this.capturePressActive = false;
    this.clearCapturePressTimer();
    this.clearRecordingTimers();
    if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
      this.mediaRecorder.onstop = null;
      this.mediaRecorder.stop();
    }
    this.isRecording = false;
    this.isRecordingPaused = false;
    this.recordingAudioStream?.getTracks().forEach(track => track.stop());
    this.recordingAudioStream = null;
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      const video = this.cameraPreview?.nativeElement;
      if(video){
        video.srcObject = null;
      }
      this.stream = null;
    }
    this.cameraReady = false;

  }
  public isVideo(url: string) {
    Capacitor.convertFileSrc(url);
    return isVideo(url);
  }

  public isImage(url: string){
    Capacitor.convertFileSrc(url);
    return isImage(url);
  }

  getText(event: any){
    this.titulo = event?.detail?.value ?? event?.target?.value ?? '';
  }

  //para archivos desde el carrete
  // Add the 'name' parameter to the function signature
  
  async setMultimediaCarrete(mediaBlob: Blob, name: string): Promise<{ filename: string; blob: Blob }> {
    const myId = uuidv4();
  
    const newPath = this.file.dataDirectory + `image_history_publication_${myId}.${name.substr(name.lastIndexOf('.') + 1)}`;
    console.log('About to call this.file.writeFile() with newPath:', newPath);
    await this.file.writeFile(this.file.dataDirectory, `image_history_publication_${myId}.${name.substr(name.lastIndexOf('.') + 1)}`, mediaBlob, { replace: true });
  
    const mediaItemConverted = new MediaItem({
      type: `image/${name.substr(name.lastIndexOf('.') + 1)}`,
      mediaPath: newPath.substr(0, newPath.lastIndexOf('/') + 1),
      name,
      id: null,
      index: 0,
      route: null,
      status: "Esperando Media",
      size: mediaBlob.size, // Use the size of the mediaBlob
      url: null,
      localUrl: newPath, // Use newPath as localUrl
      is_premium: 0,
    });
  
    console.log('multimediaitemfotoconverted', mediaItemConverted);
    this.multimedia.push(mediaItemConverted);
    console.log('Multimedia array after pushing item:', this.multimedia);
    this.formservice.multimedia = this.multimedia;
    this.image = newPath;
    this.ruta.push(this.image);
    this.formservice.history.push(History);
  
    return {
      filename: name,
      blob: mediaBlob,
    };
  }
  
  
  
  
  
  
  
  //para archivos desde camara
  setMultimediaCamera(mediaItem: MediaItem) {
    this.uploadMultimedia.image = Capacitor.convertFileSrc(mediaItem.mediaPath + mediaItem.nameFile);
    this.uploadMultimedia.readBlobFile(mediaItem.mediaPath + mediaItem.nameFile)
  .then(() => {
    this.image = this.uploadMultimedia.image;
    console.log("finalizado");
    console.log(this.image);
    this.uploadMultimedia.post().then(({ link, mimeType }) => {
      // Do something with the link and type
    }).catch((error) => {
      console.error("Error uploading file:", error);
    });
  })
  .catch((error) => {
    console.error("Error reading blob file:", error);
  });
  }
  
  setMultimediaVideo(mediaItem: MediaItem) {
    this.uploadMultimedia.image = Capacitor.convertFileSrc(mediaItem.mediaPath + mediaItem.nameFile);
    this.uploadMultimedia.readBlobFile(mediaItem.mediaPath + mediaItem.nameFile)
  .then(() => {
    this.image = this.uploadMultimedia.image;
    console.log("finalizado");
    console.log(this.image);
    this.uploadMultimedia.post().then(({ link, mimeType }) => {
      // Do something with the link and type
    }).catch((error) => {
      console.error("Error uploading file:", error);
    });
  })
  .catch((error) => {
    console.error("Error reading blob file:", error);
  });
  }
  
 // async setMultimediaCarretevideo(mediaItem: MediaItem) {
    /*console.log(mediaItem);
    this.multimedia.push(mediaItem);
    this.image= Capacitor.convertFileSrc (mediaItem.mediaPath + mediaItem.nameFile);
    console.log(' this.video',  this.image);
    this.ruta.push(this.image);
    console.log('this.ruta', this.ruta);*/
  //  const myId = uuid.v4();
 //   const savedVideoFile = await Filesystem.writeFile({
 //     path: 'video_history_publication_'+myId+'.'+mediaItem.type.replace('video/',''),
 //     data: mediaItem.mediaPath,
 //     directory: FilesystemDirectory.Data
 //   });
 //   const savedVideo = Capacitor.convertFileSrc(savedVideoFile.uri);
  //  const name = savedVideoFile.uri.substr(savedVideoFile.uri.lastIndexOf('/') + 1);
    //const mediaItemConverted = new MediaItem({
//      type: 'video/'+ name.substr(name.lastIndexOf('.') + 1),
  //    mediaPath: savedVideoFile.uri.substr(0, savedVideoFile.uri.lastIndexOf('/') + 1),
  //    name
    //});
//    console.log('multimediavideoitemconverted',mediaItemConverted);
 //   this.multimedia.push(mediaItemConverted);
   // this.formservice.multimedia = this.multimedia;
 //   this.image = savedVideo;
 //   this.ruta.push(this.image);
 //   this.formservice.history.push(History);
 // }

 // public takePhoto() {
   // this.cameraService
 //   .askForMediCapture()
//    .then((data:[MediaItem,String])=>{
  //    if(data[1].toString() === 'camara'){
    //    this.setMultimediaCamera(data[0]);
  //    }
   //   else if(data[1].toString()==='camvideo'){
    //    console.log("Estoy en video");
   //     this.setMultimediaVideo(data[0]);
     // }

//    }).catch((error)=>{
  //    Swal2.fire({
   //           title: 'Error take photo',
     //         text: error,
     //         icon: 'warning',
   //           confirmButtonText: 'Understood',
   //           color: '#ffffff',
     //         background: '#010f4e',
   //         });

    //});
 // }

  back() {
    this.modalController.dismiss({
      dismissed: true
    });
  }

  completeComposition(): void {
    if (this.composerMode !== 'social' || !this.selectedMediaBlob) return;
    void this.modalController.dismiss({
      blob: this.selectedMediaBlob,
      filename: this.selectedMediaFilename,
      type: this.mediaType,
    }, 'selected');
  }

  public async post(blobfile?: Blob, filename?: string): Promise<void> {
    const mediaBlob = blobfile || this.selectedMediaBlob;
    if (!mediaBlob || this.isPublishing) return;

    const uploadFilename = filename || this.selectedMediaFilename;
    if (!mediaBlob.size || !uploadFilename) {
      this.cameraError = 'Elige una foto o un video antes de publicar la historia.';
      return;
    }

    this.isPublishing = true;
    this.cameraError = '';
    let loadingPresented = false;
    let stage: 'create' | 'upload' | 'attach' | 'publish' = 'create';

    try {
      await this.utils.loadingPresent();
      loadingPresented = true;

      if (this.publication) {
        this.publication.title = this.titulo;
        this.publication.multimediaContainer = this.multimedia;
        this.publication.doesItHaveMultimedia = true;
      }
      const publicationData = this.publication?.getPublicationsDataToSend?.() || {};
      const publicationPayload = {
        ...publicationData,
        publication_type: 'state',
        doesItHaveMultimedia: true,
        data: { ...(publicationData.data || {}), title: this.titulo },
      };
      const rawResponse = await this.publicationService.postPublication(publicationPayload);
      const story = this.normalizeStoryResponse(rawResponse);
      const publicationId = Number(story?.id ?? story?.publication_id ?? story?.publication?.id);
      const stateId = Number(story?.state_id ?? story?.state?.id ?? story?.story?.state_id);
      if (!publicationId || !stateId) {
        throw new Error('El servidor no devolvió los identificadores de la historia.');
      }

      stage = 'upload';
      const { link, mimeType } = await this.uploadMultimedia.post(mediaBlob, uploadFilename);
      if (!link) throw new Error('El servidor no devolvió la URL del archivo.');

      stage = 'attach';
      const isVideoMedia = String(mimeType || mediaBlob.type).toLowerCase().startsWith('video/');
      await this.request.createRequestPost('publications.multimedia', {
        route: link,
        size: Math.max(1, Math.round(mediaBlob.size / 1024)),
        type: isVideoMedia ? 'video' : 'imagen',
        publication_type: 'story',
        state_id: stateId,
        publication_id: publicationId,
        is_premium: false,
      });

      stage = 'publish';
      if (Capacitor.getPlatform() !== 'web') {
        try {
          await this.updateStatusPublication([publicationId, stateId]);
        } catch (statusError) {
          // Preserve the established web flow; native status updates are a
          // follow-up to attaching media and must not block a completed Story.
          console.warn('Story media was attached, but its status update failed.', statusError);
        }
      }
      try {
        const createdStory = await this.publicationService.getPublicationByID(publicationId, true);
        if (createdStory) {
          await this.publicationService.updatePublicationList('MyStoriesList', createdStory, true);
        }
      } catch (refreshError) {
        console.warn('Story was published, but the local story list could not refresh.', refreshError);
      }

      this.isPublishing = false;
      if (loadingPresented) await this.utils.loadingDismiss();
      await this.back();
    } catch (error) {
      console.error('Unable to publish story.', error);
      this.isPublishing = false;
      if (loadingPresented) await this.utils.loadingDismiss();
      this.cameraError = stage === 'create'
        ? 'No se pudo crear la historia. Comprueba tu conexión e inténtalo de nuevo.'
        : stage === 'upload'
          ? 'No se pudo subir la foto o el video. Comprueba tu conexión e inténtalo de nuevo.'
          : stage === 'attach'
            ? 'El archivo se subió, pero no se pudo asociar a la historia. Inténtalo de nuevo.'
            : 'La historia se guardó, pero no se pudo actualizar su estado. Inténtalo de nuevo.';
    }
  }

  private normalizeStoryResponse(rawResponse: any): any {
    let response = rawResponse;
    for (let depth = 0; depth < 5; depth++) {
      if (typeof response === 'string') {
        response = JSON.parse(response);
        continue;
      }
      if (response?.data && !response.id) {
        response = response.data;
        continue;
      }
      if (response?.result && !response.id) {
        response = response.result;
        continue;
      }
      break;
    }
    return response;
  }

  public updateStatusPublication(publication_ids: Array<number>) {
      // Log the publication_ids array
      console.log('publication_ids:', publication_ids);
    return new Promise((resolve, reject) => {
      const status = {
        publication_type: 'publication',
        data: {
          publication_status_id: 1,
        },
      };
      this.publicationService
        .putPublication(status, publication_ids[0])
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  async pickMulti(){
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*,video/*';
    input.multiple = false;
    input.addEventListener('change', (event: Event) => {
      const file = (event.target as HTMLInputElement).files?.[0];
      if (!file) return;
      const kind = file.type.startsWith('video/') ? 'video' : 'image';
      this.setSelectedMedia(file, file.name || this.createFilename(kind === 'video' ? 'mp4' : 'jpg'), kind);
      this.ref.detectChanges();
    }, { once: true });
    input.click();
  }  
  
  
    

pickmedia_selection(){
  this.pickMulti();
}
LaniakeaMediaPicker(){
  Swal2.fire({
    title: 'Selecciona una foto',
    text: `Would you like to choose the image from Google Drive or from your device?`,
    icon: 'info',
    //timer: 6900, // Show the alert for 3.9 seconds
    //timerProgressBar: true,
  //	toast: true,
  //	position: 'top-end',
    showCancelButton: true,
    confirmButtonText: 'Google Drive',
    cancelButtonText: 'Este dispositivo',
    color: '#ffffff',
    background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
    }).then((result) => {
    if (result.isConfirmed) {
     // this.googlePicker();
    }else{
   // this.pickImage();
    }
    });

  }
  
  
  public pickMedia() { 
    this.pickMulti();
  }

  
 public pickMedia2(): void {
  const options = {
    quality: 80,
    destinationType: navigator.camera.DestinationType.FILE_URI,
    mediaType: navigator.camera.MediaType.ALLMEDIA,
    sourceType: navigator.camera.PictureSourceType.PHOTOLIBRARY,
  };

  navigator.camera.getPicture(
    async (mediaUrl: string) => {
      console.log('Media picked successfully:', mediaUrl);
      this.safeVideoUrl = null; // Reset safeVideoUrl
      this.uploadMultimedia.image = null; // Reset uploadMultimedia.image

      if (this.isImageMediaType(mediaUrl)) {
        // Image media
        this.uploadMultimedia.image = mediaUrl;
      } else if (this.isVideoMediaType(mediaUrl)) {
        // Video media
        this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(mediaUrl);
      }

      try {
        //const blobfile = await this.convertMediaUriToBlob(mediaUrl);
        const filename = this.getFilenameFromUri(mediaUrl);

        // Process the media here
        // ...

        // Uncomment the line below if you need to upload the media file
        // await this.post(blobfile, filename);
      } catch (error) {
        console.error('Error occurred during media conversion:', error);
      }
    },
    (error: any) => {
      console.log('Error capturing media:', error);
    },
    options
  );
}

private isImageMediaType(mediaUrl: string): boolean {
  // Implement your logic to determine if the media is an image
  // You can use file extensions or other criteria to identify images
  return mediaUrl.endsWith('.jpg') || mediaUrl.endsWith('.jpeg') || mediaUrl.endsWith('.png');
}

private isVideoMediaType(mediaUrl: string): boolean {
  // Implement your logic to determine if the media is a video
  // You can use file extensions or other criteria to identify videos
  return mediaUrl.endsWith('.mp4') || mediaUrl.endsWith('.mov') || mediaUrl.endsWith('.avi');
}



private async convertMediaUriToBlob(mediaUrl: string): Promise<Blob> {
  const response = await fetch(mediaUrl);
  const blob = await response.blob();
  return blob;
}







private getFilenameFromUri(uri: string): string {
  const lastSlashIndex = uri.lastIndexOf('/');
  return uri.substr(lastSlashIndex + 1);
}


  
  
  
  
  
  
}
  
  
  
  

 
  

  // Add the 'name' parameter to the function signature
 
  
    
  
